import { useEffect, useRef, useState } from "react";

import "../../assets/css/fullscreen.css";
import "../../assets/css/__fn.style.css";

import { observer } from "mobx-react-lite";

import exitTileView from "../../assets/images/exit-tile-view.svg";
import Comments from "../../components/Comments";
import MeetingLifecycleViewer from "../../components/meeting-status-layouts/meeting-lifecycle-viewer";
import { TileViewScreenItem } from "../../components/tile-view";
import Timeline from "../../components/timeline";
import VideoMeeting from "../../components/video-meeting";
import { useMeetingDetailsStore } from "../../contexts/meetingDetails/meetingDetailsContext";
import { useScreenIO } from "../../contexts/screenIO/joinedMeetingScreenIOContext";
import useFullscreen from "../../hooks/useFullscreen";

import MKSteps from "./mouse-keyboard-steps";
import StepList from "./step-list";
import Topbar from "./topbar";

const MeetingRoom = observer(() => {
  const fullscreenElementRef = useRef();
  const { releaseMouseControl, releaseKeyboardControl } = useScreenIO();
  const { isJoined, isLeaving, meeting } = useMeetingDetailsStore();
  const { openFullscreen, exitFullscreen, inFullscreen } = useFullscreen({
    fullscreenElementRef,
    onExit: () => {
      releaseMouseControl();
      releaseKeyboardControl();
    },
  });

  const [allControllerElementsVisibility, updateAllControllerElementsVisibility] = useState(true);
  const [macLikeAnimationState, updateMacLikeAnimationState] = useState(true);
  const [showVideoMeeting, setShowVideoMeeting] = useState(false);

  useEffect(() => {
    updateMacLikeAnimationState(allControllerElementsVisibility);
  }, [allControllerElementsVisibility]);

  const animationClass = allControllerElementsVisibility ? "animation-hide" : "animation-show";
  const fullscreenClass = inFullscreen ? "in-full-screen-mode" : "in-player-mode";

  const activeMeeting = isJoined && !isLeaving;

  return (
    <div id="container" className={`${animationClass} ${fullscreenClass}`} ref={fullscreenElementRef}>
      <MeetingLifecycleViewer meetingStatus={meeting?.status} openFullscreen={openFullscreen} inFullscreen={inFullscreen} />

      {activeMeeting && <Timeline />}

      {((activeMeeting && macLikeAnimationState) || (!activeMeeting && macLikeAnimationState && inFullscreen)) && (
        <div className="absolute top-90 right-10 comments-container-parrent">
          <Comments />
        </div>
      )}

      {((activeMeeting && macLikeAnimationState) || (!activeMeeting && macLikeAnimationState && inFullscreen)) && (
        <div
          className="dev-mode align-center pointer m-r-10 show-video-meeting-label"
          style={{
            position: "absolute",
            right: "0",
            marginTop: "230px",
            padding: "10px",
            borderRadius: "15px",
          }}
          onClick={() => setShowVideoMeeting((x) => !x)}>
          VIDEO-MEETING
        </div>
      )}

      {showVideoMeeting && <VideoMeeting />}

      {((activeMeeting && macLikeAnimationState) || (!activeMeeting && macLikeAnimationState && inFullscreen)) && (
        <Topbar
          exitFullscreen={exitFullscreen}
          allControllerElementsVisibility={allControllerElementsVisibility}
          updateAllControllerElementsVisibility={updateAllControllerElementsVisibility}
        />
      )}

      {((activeMeeting && macLikeAnimationState) || (!activeMeeting && macLikeAnimationState && inFullscreen)) && <MKSteps />}
      {((activeMeeting && macLikeAnimationState) || (!activeMeeting && macLikeAnimationState && inFullscreen)) && <StepList />}

      {!allControllerElementsVisibility && (
        <div className={`tile-view ${allControllerElementsVisibility ? "hide" : "show"}`}>
          <div className="container">
            <button onClick={() => updateAllControllerElementsVisibility(true)} className="icon-action exit-tile-view">
              <img src={exitTileView} alt="" />
            </button>
            <div className="screen-list">
              <TileViewScreenItem updateFullScreenUI={updateAllControllerElementsVisibility} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
});

export default MeetingRoom;
